var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88669 6.18506C7.88669 4.99158 8.3608 3.84699 9.20471 3.00308C10.0486 2.15916 11.1932 1.68506 12.3867 1.68506C13.5802 1.68506 14.7248 2.15916 15.5687 3.00308C16.4126 3.84699 16.8867 4.99158 16.8867 6.18506C16.8867 7.37853 16.4126 8.52313 15.5687 9.36704C14.7248 10.211 13.5802 10.6851 12.3867 10.6851C11.1932 10.6851 10.0486 10.211 9.20471 9.36704C8.3608 8.52313 7.88669 7.37853 7.88669 6.18506ZM4.13769 20.2901C4.17141 18.1245 5.05533 16.0591 6.59865 14.5396C8.14197 13.0202 10.2209 12.1685 12.3867 12.1685C14.5525 12.1685 16.6314 13.0202 18.1747 14.5396C19.7181 16.0591 20.602 18.1245 20.6357 20.2901C20.6383 20.4358 20.5983 20.5792 20.5207 20.7027C20.4431 20.8261 20.3312 20.9242 20.1987 20.9851C17.7479 22.1088 15.0829 22.6887 12.3867 22.6851C9.60069 22.6851 6.95369 22.0771 4.57469 20.9851C4.44218 20.9242 4.33027 20.8261 4.25265 20.7027C4.17504 20.5792 4.13509 20.4358 4.13769 20.2901Z",
    fill: "#0A122A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.656a3b2707a3e68792d3faa5b9bffc22.svg";
export { ForwardRef as ReactComponent };